import * as React from "react";

import {
  useProductListAutoInitialization,
  useProductListLoadingState,
  useProductListPresentationModel,
} from "../providers";

import { ProductMasonry } from "../product-masonry";
import { ProductMasonryPaginationContainer } from "../product-masonry-pagination-container";

import { ZeroFilterResults } from "./zero-filter-results";

export const Content: React.FunctionComponent = () => {
  const { hasInitialized } = useProductListAutoInitialization();
  const { isLoading: isTheProductListLoading } = useProductListLoadingState();
  const { presentationProducts } = useProductListPresentationModel();

  const showNothing = !hasInitialized;

  const showZeroFilterResults =
    hasInitialized &&
    !isTheProductListLoading &&
    presentationProducts.length < 1;

  return (
    <React.Fragment>
      {showNothing ? null : showZeroFilterResults ? (
        <ZeroFilterResults />
      ) : (
        <ProductMasonryPaginationContainer>
          <ProductMasonry />
        </ProductMasonryPaginationContainer>
      )}
    </React.Fragment>
  );
};
